import React, {useEffect, useState} from 'react';
import {useShallow} from 'zustand/react/shallow';
import {Box, Snackbar} from '@mui/material';
import contentStudioStore, {
  contentStudioActions,
} from '@/stores/contentStudioStore';
import MainErrorDisplay from './MainErrorDisplay';
import SingleErrorDisplay from './SingleErrorDisplay';

function ErrorToast() {
  const {errors} = contentStudioStore(
    useShallow((state) => ({
      errors: state.errors,
    }))
  );
  const [isOpen, setIsOpen] = useState(true);
  useEffect(() => {
    setIsOpen(true);
  }, [errors]);
  return (
    <Snackbar
      open={errors.length > 0}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      sx={{
        width: 'fit-content',
        margin: '0 auto',
      }}
    >
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          alignItems: 'center',
        }}
      >
        <MainErrorDisplay
          errorAmount={errors.length}
          onClear={() => {
            contentStudioActions.clearErrors();
            setIsOpen(false);
          }}
          isOpen={isOpen}
          setIsOpen={() => setIsOpen(!isOpen)}
        />
        {isOpen &&
          errors.map((error) => (
            <SingleErrorDisplay
              key={error.id}
              errorTitle={error.title}
              errorDescription={error.description}
              errorKind={error.kind}
              onClose={() => {
                contentStudioActions.removeError(error.id);
              }}
            />
          ))}
      </Box>
    </Snackbar>
  );
}

export default ErrorToast;
